import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { CustomerVesselDocumentClientModel, ExistingDocumentModel, SaveVesselFormRequest, SaveVesselFormResponse, UploadCustomerDocumentRequest, UploadCustomerDocumentsResponse, UploadDocumentRequest } from "../models/document-management.models";
import { CloneHelper } from "@rightship-tech/common-ui/helpers/clone.helper";

@autoinject
export class DocumentManagementApi {

    public documentManagementApi: string = `${this.configService.config.urls.documentManagementApiUrl}/api/v1/DocumentManagement`;
    public inspectionsApi: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/RightShipInspection`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    //Save vessel form
    public saveVesselForm(request: SaveVesselFormRequest): Promise<SaveVesselFormResponse> {
        return this.requestClientService.post(`${this.documentManagementApi}/SaveVesselForm`, {}, request);
    }

    //Delete vesse document
    public deleteDocument(id: number): Promise<any> {
        return this.requestClientService.post(`${this.documentManagementApi}/DeleteDocument`, {}, { vesselDocumentId: id });
    }

    //Delete customer vessel document
    public deleteCustomerVesselDocument(ids: number[]): Promise<any> {
        return this.requestClientService.post(`${this.documentManagementApi}/DeleteCustomerVesselDocument`, {}, { customerVesselDocumentIds: ids });
    }

    //Delete vessel form
    public deleteForm(id: number): Promise<any> {
        return this.requestClientService.post(`${this.documentManagementApi}/DeleteForm`, {}, { vesselFormId: id });
    }

    //Download document
    public downloadDocument(id: number, name: string, encryptedData?: string): void {
        const encodedEncryptedData = encryptedData ? `&encryptedData=${encodeURIComponent(encryptedData)}` : '';
        window.open(`${this.documentManagementApi}/DownloadDocument?name=${name}&vesselDocumentId=${id}${encodedEncryptedData}`, "_blank");
    }

    //Download all document
    public downloadAllDocuments(rightShipInspectionId: number, name: string, encryptedData?: string): void {
        if (encryptedData) {
            window.open(`${this.inspectionsApi}/DownloadAllDocuments/${rightShipInspectionId}/${name}?encryptedData=` + encodeURIComponent(encryptedData), "_blank");
        }
        else {
            window.open(`${this.inspectionsApi}/DownloadAllDocuments/${rightShipInspectionId}/${name}`, "_blank");
        }
    }

    //Download customer document
    public downloadCustomerDocument(id: number, otherDocumentType: string, name: string): void {
        window.open(`${this.documentManagementApi}/DownloadCustomerDocument?name=${name}&documentTypeId=${id}${otherDocumentType ? '&otherDocumentType=' : ''}${otherDocumentType ?? ''}`, "_blank");
    }

    //upload document
    public uploadDocument(request: UploadDocumentRequest): Promise<void> {
        return this.requestClientService.postFormData(`${this.documentManagementApi}/UploadDocument`, request);
    }

    //List RightShip Inspection document access
    public async listRightshipInspectionDocumentAccess(rightshipInspectionId: number): Promise<any> {
        return await this.requestClientService.post<any>(this.configService.config.urls.documentManagementApiUrl + '/api/v1/InspectionAccess/ListAccess', null, {
            accessDetails: {
                rightshipInspectionId: rightshipInspectionId,
                emails: []
            }
        });
    }

    //Remove RightShip Inspection document access
    public async removeRightshipInspectionDocumentAccess(rightshipInspectionId: number, emails: string[]): Promise<any> {
        return await this.requestClientService.post<any>(this.configService.config.urls.documentManagementApiUrl + '/api/v1/InspectionAccess/RemoveAccess', null, {
            accessDetails: {
                rightshipInspectionId: rightshipInspectionId,
                emails: emails
            }
        });
    }

    //This method will call the Qi api to send the email to the shared email addresses
    public async shareRightshipInspectionDocumentAccess(rightshipInspectionId: number, emails: string[], isResendEmail: boolean, emailContent: string): Promise<any> {
        return await this.requestClientService.post<any>(this.configService.config.urls.rightShipPlatformApiUrl + '/api/v1/RightShipInspection/ShareOutcomeReport', null, {
            rightShipInspectionId: rightshipInspectionId,
            emails: emails,
            isResendEmail: isResendEmail,
            emailContent: emailContent
        });
    }

    //Get customer uploaded documents
    public getCustomerUploadDocuments(entityTypeId: number, entityId: number): Promise<CustomerVesselDocumentClientModel[]> {
        return this.requestClientService.get<CustomerVesselDocumentClientModel[]>(`${this.documentManagementApi}/GetCustomerUploadDocuments/${entityTypeId}/${entityId}`, {});
    }

    //upload document
    public uploadCustomerDocuments(request: UploadCustomerDocumentRequest, progressCallback: (event: ProgressEvent) => void): Promise<UploadCustomerDocumentsResponse> {
        const requestModel = CloneHelper.cloneObject(request);
        const data = this.requestClientService.appendToFormData(requestModel);
        return this.requestClientService.postWithProgressCallback(`${this.documentManagementApi}/UploadCustomerDocuments`, progressCallback, {}, data);
    }

    public overridExistingDocuments(ids: number[]): Promise<void> {
        return this.requestClientService.post(`${this.documentManagementApi}/OverridExistingDocuments`, {}, { customerVesselDocumentIds: ids });
    }

    public saveSatisfyDocumentRequirement(ids: number[], satisfyDocumentRequirements: boolean, overrideExistingDocuments: boolean = false): Promise<ExistingDocumentModel[]> {
        return this.requestClientService.post(`${this.documentManagementApi}/SaveSatisfyDocumentRequirement`, {}, { customerVesselDocumentIds: ids, satisfyDocumentRequirements: satisfyDocumentRequirements, overrideExistingDocuments: overrideExistingDocuments });
    }
}
